import React from 'react';
import PropTypes from 'prop-types';
import { DataCell } from '../../../common/tables/V2';

export default function ConditionalDataCell({ value, condition }) {
  return condition ? (
    <DataCell>
      {value}
    </DataCell>
  ) : null;
}

ConditionalDataCell.propTypes = {
 value: PropTypes.string.isRequired,
 condition: PropTypes.bool.isRequired,
};
